const assetsPath = 'static/'
const imgPath = assetsPath + 'img/'
const bgPath = imgPath + 'bg/'
const galleryPath = imgPath + 'gallery/'
const logoPath = imgPath + 'logo/'
const teamPath = imgPath + 'team/'
const iconPath = imgPath + 'icons/'

export {
  assetsPath,
  imgPath,
  bgPath,
  galleryPath,
  logoPath,
  teamPath,
  iconPath
}

export default {
  assetsPath,
  imgPath,
  bgPath,
  logoPath,
  teamPath,
  iconPath
}
